export const DEFAULT_MOTIVATION_CONFIG = {
    hoursCoefficient: 0.98,
    hourTiers: [
        { maxHours: 100, rate: 5, mode: 'all' },
        { maxHours: 135, rate: 5.5, mode: 'all' },
        { maxHours: 165, rate: 6, mode: 'all' },
        { maxHours: null, rate: 6.5, mode: 'overflow', baseHours: 165, baseRate: 6 },
    ],
    occBonusTiers: [
        { occFrom: 0, occTo: 40, percent: 0 },
        { occFrom: 40, occTo: 50, percent: 10 },
        { occFrom: 50, occTo: 60, percent: 13 },
        { occFrom: 60, occTo: 100, percent: 15 },
    ],
    defaultBonusPercent: 10,
    contractMonthlySalary: 1600,
    hoursPerDay: 8,
};

export const cloneMotivationConfig = (config = DEFAULT_MOTIVATION_CONFIG) => {
    const next = JSON.parse(JSON.stringify({
        ...DEFAULT_MOTIVATION_CONFIG,
        ...config,
        hourTiers: config.hourTiers || DEFAULT_MOTIVATION_CONFIG.hourTiers,
        occBonusTiers: config.occBonusTiers || DEFAULT_MOTIVATION_CONFIG.occBonusTiers,
    }));
    if (!Number(next.hoursPerDay)) next.hoursPerDay = 8;
    if (next.contractMonthlySalary == null || next.contractMonthlySalary === '') {
        next.contractMonthlySalary = 1600;
    }
    return next;
};

export const emptyHourTier = () => ({ maxHours: 100, rate: 5, mode: 'all' });
export const emptyOccTier = () => ({ occFrom: 0, occTo: 40, percent: 0 });
